import axiosInstance from '../../../../lib/axios';
import type { ReferralListParams, ReferralPage } from '../types';

const BASE = '/v1/admin/referrals';

export const listReferrals = async (params: ReferralListParams) => {
  const response: { data: { data: ReferralPage } } = await axiosInstance.get(BASE, {
    params: { ...params, status: params.status || undefined, search: params.search || undefined },
  });
  return response.data.data;
};

export const revokeReferral = async (publicId: string) => {
  const response: { data: { data: { revokedCoupons: number } } } = await axiosInstance.post(
    `${BASE}/${publicId}/revoke`
  );
  return response.data.data;
};
